<template>
    <span>
        <span class="cursor-pointer" @click="showTable = true"
            ><strong>tabela de medidas</strong></span
        >
        <Modal v-model="showTable" class="large">
            <template v-slot:title>Medidas</template>
            <div class="card-block form-inline">
                <label>Selecione a modelagem:</label>
                <SelectField v-model="selectedModeling">
                    <option v-for="modeling in modelsData" :value="modeling">
                        {{ getModelName(modeling) }}
                    </option>
                </SelectField>
            </div>
            <div class="card-block">
                <div class="flex-grid my-0">
                    <div class="flex-xs-12 flex-md-4 py-0" style="align-self: center">
                        <img
                            v-show="selectedModeling"
                            :src="`${$scope.CDN_IMAGES}/${selectedModeling.dimension_image_url}?auto=compress,format&q=65`"
                            class="img-responsive"
                        />
                    </div>
                    <div class="flex-xs-12 flex-md-8 py-0" style="align-self: center">
                        <SizesTableV2
                            v-show="selectedModeling"
                            :selected-modeling="selectedModeling"
                        />
                    </div>
                </div>
            </div>
        </Modal>
    </span>
</template>

<script>
    import SelectField from '../../../../../submodules/src/components/input/select-field/SelectField.vue';
    import Modal from '../common/container/Modal';
    import SizesTableV2 from '../product-model/SizesTableV2.vue';
    import product from '../../i18n/product';

    export default {
        name: 'SizesGuideTableV2',

        components: { SelectField, Modal, SizesTableV2 },

        props: {
            modelsData: {
                type: Array,
                required: false,
            },
        },

        data() {
            return {
                selectedModeling: this.modelsData[0],
                showTable: false,
            };
        },

        methods: {
            product,
            getModelName(data) {
                return data.product_type.nome + ' ' + (data.filter_name || '');
            },
        },
    };
</script>
